// extracted by mini-css-extract-plugin
module.exports = {"charge":"capacity_charge__4iaYG"};